export const NO_DATA_INPUTS_PLACEHOLDER = 'No data inputs available';
export const NO_DATA_INPUTS_DESCRIPTION = 'Add a data source or use an upstream step output.';
export const NO_CHILD_OUTPUTS_PLACEHOLDER = 'No child outputs available';
export const NO_CHILD_OUTPUTS_DESCRIPTION = 'Add a child step output before selecting one.';
